import { mapPersonalInfoType, PersonalInfoType } from "./PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "./UserRoleInfoType";

export interface ContactEmployeeType {
    contact_id?: number;
    contact_type?: string;
    contact_subtype?: string;
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}

// to single object maping
export const mapContactEmployeeType = (data: any): ContactEmployeeType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: ContactEmployeeType = {
        contact_id: data.contact_id,
        contact_type: data.contact_type,
        contact_subtype: data.contact_subtype,
        personalInfo: (data.personalInfo !== null) ? mapPersonalInfoType(data.personalInfo) : null,
        userRoleInfo: (data.userRoleInfo !== null) ? mapUserRoleInfoType(data.userRoleInfo) : null,
    }
    return res;
}

// maping list objects
export const mapContactEmployeeTypes = (data: any[]): ContactEmployeeType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapContactEmployeeType);
}